/* ============================================================
   RUNNIES — runnies-theme.js
   ============================================================ */
(function(){
  'use strict';

  /* ---- SEARCH BAR ---- */
  const searchToggle = document.getElementById('rn-search-toggle');
  const searchBar    = document.getElementById('rn-search-bar');
  const searchClose  = document.getElementById('rn-search-close');
  if(searchToggle && searchBar){
    searchToggle.addEventListener('click', () => searchBar.classList.toggle('is-open'));
    searchClose && searchClose.addEventListener('click', () => searchBar.classList.remove('is-open'));
  }

  /* ---- CART DRAWER ---- */
  const cartToggle  = document.getElementById('rn-cart-toggle');
  const cartDrawer  = document.getElementById('rn-cart-drawer');
  const cartOverlay = document.getElementById('rn-cart-overlay');
  const cartClose   = document.getElementById('rn-cart-close');
  const cartCount   = document.getElementById('rn-cart-count');
  const cartBody    = document.getElementById('rn-cart-body');
  const cartEmpty   = document.getElementById('rn-cart-empty');
  const cartItems   = document.getElementById('rn-cart-items');
  const cartFooter  = document.getElementById('rn-cart-footer');
  const cartSubtotal= document.getElementById('rn-cart-subtotal');

  function openCart(){ cartDrawer.classList.add('is-open'); cartOverlay.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden','false'); fetchCart(); }
  function closeCart(){ cartDrawer.classList.remove('is-open'); cartOverlay.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden','true'); }

  cartToggle  && cartToggle.addEventListener('click', openCart);
  cartClose   && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  function moneyFormat(cents){
    return (cents/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});
  }

  function renderCart(cart){
    if(!cartItems) return;
    if(cart.item_count === 0){
      cartEmpty  && (cartEmpty.style.display = 'flex');
      cartItems.innerHTML = '';
      cartFooter && (cartFooter.style.display = 'none');
    } else {
      cartEmpty  && (cartEmpty.style.display = 'none');
      cartFooter && (cartFooter.style.display = 'block');
      if(cartSubtotal) cartSubtotal.textContent = moneyFormat(cart.total_price);
      cartItems.innerHTML = cart.items.map(item => `
        <div class="rn-cart-item">
          <img src="${item.image}" alt="${item.title}" width="72" height="72">
          <div class="rn-cart-item__info">
            <div class="rn-cart-item__title">${item.product_title}</div>
            <div class="rn-cart-item__variant">${item.variant_title || ''}</div>
            <div class="rn-cart-item__qty">
              <button onclick="window.rnUpdateCart('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button onclick="window.rnUpdateCart('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <button class="rn-cart-item__remove" onclick="window.rnUpdateCart('${item.key}', 0)">Supprimer</button>
          </div>
          <span class="rn-cart-item__price">${moneyFormat(item.line_price)}</span>
        </div>
      `).join('');
    }
    if(cartCount){
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
  }

  function fetchCart(){
    fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(console.error);
  }

  window.rnUpdateCart = function(key, qty){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(r=>r.json()).then(renderCart).catch(console.error);
  };

  /* Écouter les ajouts au panier depuis le formulaire produit */
  document.addEventListener('submit', function(e){
    const form = e.target.closest('#rn-product-form');
    if(!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: fd.get('id'), quantity: 1 })
    })
    .then(r=>r.json())
    .then(()=>{ fetchCart(); openCart(); })
    .catch(console.error);
  });

  /* Init compteur panier au chargement */
  fetchCart();

})();
